export class CmodalModel {

    id: string
    typ: string // 'formy', 'grid', ...
    title: string
    opt: any
    output: any
    width: string
    model: any
    onclosed: any

    constructor(typ: string, id: string, title: string, model: any) {
        this.typ = typ
        this.id = id
        this.title = title
        this.model = model
    }
}